import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: [
    'asin_id',
    'video_platform_id',
    'title',
    'category',
    'language',
    'regions',
    'note',
    'publish_date',
    'cancel_date'
  ],
  titles: [
    store.__('asin id'), store.__('Video ID'),
    store.__('title'), store.__('category'), store.__('language'),
    store.__('regions'), store.__('note'), store.__('published'),
    store.__('canceled')
  ],
  _sortField: 'title',
  validators: {
    video_platform_id: Validators.isMandatory(store),
    title: Validators.isMandatory(store),
    category: Validators.isMandatory(store),
    regions: Validators.regionTest(store),
    publish_date: Validators.isDate(store),
    cancel_date: Validators.isDate(store)
  }
})
